const getStepIndex = (mainFlowSteps, step) => {
	const stepIdx = mainFlowSteps.findIndex((stepInArray) => stepInArray === step)
	return stepIdx !== -1 ? stepIdx : null
}

export {
	getStepIndex,
}
